import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Field, getFormValues, reduxForm } from 'redux-form';
import {
  Button,
} from '../../../../../../common/components';
import { MarketingField } from '../Marketing/Marketing';
import Communications from '../../../Communications';
import CovidStatement from '../../../CovidStatement/CovidStatement';
import cx from 'classnames';
import displayCurrency from '../../../../../../helpers/displayCurrency';
import Declaration
  from '../../../LeisureTravelForm/Components/Fields/Declaration/Declaration';
import { required } from 'redux-form-validators';
import axios from 'axios';

const getErrors = (validationErrors) => {
  if (!validationErrors) {
    return [];
  }
  return Object.keys(validationErrors).reduce((carry, errorKey) => {
    if (!validationErrors[errorKey]) {
      carry.push(errorKey + ' required');
    }
    return carry;
  }, []);
};

const PaymentButton = ({ input, meta, type },) => {

  const handleSelect = () => {
    input.onChange(type);
  };
  return (
    <Button
      className={
        cx({
          'error': meta.error && meta.submitFailed

        })
      }
      label={<div className="payment-type-label capitalise"> {type} </div>}
      handleClick={handleSelect}
    />
  );
};
const PaymentTypes = ({ isBroker, show, meta }) => {
    if (!show) {
      return null;
    }

    return (
      <>
        <div className={'payment-buttons'}>
          <div>
            <Field
              name={'meta.payment_type'}
              type={'card'}
              label={'card'}
              component={PaymentButton}
              className={'btn-payment pad-right'}
            />
          </div>

          {isBroker && (
            <div>
              <Field
                name={'meta.payment_type'}
                type={'account'}
                label={'Broker Account'}
                component={PaymentButton}
                className={'btn-payment pad-right'}
                // className={`btn-payment ${classButton('Broker Account')}`}
              />
            </div>
          )}


        </div>
        {meta && meta.touched && meta.error && (
          <span className="input-error">{meta.error}</span>
        )}
      </>

    );


  };

const PaymentTab = ({
  isBroker,
  covidMessage,
  applicationErrors,
  formValues,
  isMta,
  purchaseDeclaration,
  hasSignpostedPremiums,
  purchasePremium,
  onIssue,
  isIssuing,
  product,
  onTransactionEmergencyBrakes,
  onFailTransaction,
  onCompleteTransaction
}) => {

  const errors = getErrors(applicationErrors);

  const taxRate = purchasePremium?.rates?.tax_rate ?? 0;

  const issue = (values) => {
    onIssue(values);
  };

  const handleIssue = () => {
    issue(formValues);
  };

  const handleWindowMessage = (event) => {
    // For Chrome, the origin property is in the event.originalEvent object.
    const origin = event.origin || event.originalEvent.origin;

    if (origin !== axios.defaults.baseURL) {
      return;
    }

    const data = event.data;

    if (data.status !== 'complete') {
      // dispatch(productActions.failTransaction(data.message));
      onFailTransaction(data.message);
      return;
    }
    onCompleteTransaction(data.policies[0].policy_id);
    // dispatch(productActions.completeTransaction(data.policies[0].policy_id));
  };

  useEffect(() => {
    // dispatch(parentChange('data.current_tab', 6));

    if (process.env.BROWSER) {
      window.addEventListener('message', handleWindowMessage);
    }

    return () => {
      if (process.env.BROWSER) {
        window.removeEventListener('message', handleWindowMessage);
      }
      if (product.isCompletingTransaction) {
        onTransactionEmergencyBrakes();
        // dispatch(productActions.transactionEmergencyBrakes());
      }
    };
  }, []);

  const renderCompleteTransactionFrame = () => {
    const url =
      axios.defaults.baseURL + '/public/transactions/' + product.transactionId + ':pay';
    return (
      <div className="payment__container">
        <iframe src={url} className="payment__iframe"/>
      </div>
    );
  };

  const isPurchaseDeclarationAgreed = formValues?.meta?.purchase_declaration;

  if (product.isCompletingTransaction) {
    return renderCompleteTransactionFrame();
  }

  if (errors.length > 0) {
    return (
      <div className="row">
        <div className="col-xs-12">
          <h4>Not ready for issuing</h4>
          {errors.length > 0 && (
            <div>
              <p>Please resolve the following issues:</p>
              <ul>
                {errors.map((errorItem, i) => (
                  <li key={i}>{errorItem}</li>
                ))}
              </ul>
            </div>
          )}
        </div>
      </div>
    );
  }


  const showPaymentOptions = isPurchaseDeclarationAgreed || isMta;
  const amountDue = formValues?.meta?.amount;

  return (
    <div>
      <Communications name={'data.attributes.metadata.communications'}/>
      <hr/>

      <>
        <div className="marketing-title">
          <h4>Marketing</h4>
        </div>
        <Field
          name={'data.attributes.metadata.adults[0].marketing_options'}
          showText
          component={MarketingField}
        />

      </>
      <hr/>
      <Declaration
        show={!isMta}
        declaration={purchaseDeclaration}
        hasSignpostedPremiums={hasSignpostedPremiums}
        selectedPremium={purchasePremium}
      />
      <div>
        <CovidStatement covidMessage={covidMessage} showAgreement={false}/>
      </div>
      {showPaymentOptions && (
        <div>
          <hr/>
          <h4>Payment Details</h4>
          <Field
            name={'meta.payment_type'}
            component={PaymentTypes}
            isBroker={isBroker}
            show={!isMta || (isMta && amountDue > 0)}
            validate={required({ msg: 'Payment type is required' })}
          />

          <div className="divider"/>
          {amountDue !== undefined && (
            <div className="total-premium">
              <span>Total to pay:</span>
              <span className="total-premium red">
                &nbsp;
                {displayCurrency(amountDue)}
                <span style={{ fontSize: '0.8em' }}>
                  &nbsp;including {taxRate}% Insurance Premium Tax (IPT)
                </span>
              </span>
            </div>
          )}
          <div className="payment-options-container">
            <Button
              bsStyle="primary"
              isLoading={isIssuing}
              handleClick={handleIssue}

              label="Issue Policy"
            />
          </div>
        </div>
      )}
    </div>
  );

};

const FORM_NAME = 'IssuePolicyDialog';


export default connect(
  (state, ownProps) => ({
    initialValues: {
      data: {
        attributes: {
          metadata: {
            communications: {},
            adults: {
              ...ownProps.application?.data?.attributes?.metadata?.adults


            }
          }
        },
        relationships: {
          premium: {
            data: {
              type: 'premium',
              id: ownProps?.purchasePremiumId,
            },
          },
        },
      },

      meta: {
        // product_code: get(ownProps.product, 'data.attributes.product_code', ''),
        sms_send: false,
        purchase_declaration: false,
        payment_type: null,
        amount: ownProps?.purchasePremium?.gross
      },
    },
    formValues: getFormValues(FORM_NAME)(state),
  }))(reduxForm({ form: FORM_NAME })(PaymentTab));
